import { render } from "./FileTemplate.vue?vue&type=template&id=778715ea&scoped=true"
import script from "./FileTemplate.vue?vue&type=script&lang=js"
export * from "./FileTemplate.vue?vue&type=script&lang=js"

import "./FileTemplate.vue?vue&type=style&index=0&id=778715ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-778715ea"]])

export default __exports__